import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SuggestedUserState } from './suggested-user.state';

import * as fromSuggestedUser from './suggested-user.reducer';

export const selectSuggestedUserState = createFeatureSelector<SuggestedUserState>('suggested-users');

export const selectSuggestedUserIds = createSelector(
  selectSuggestedUserState,
  fromSuggestedUser.selectSuggestedUserIds
);

export const selectAllSuggestedUsers = createSelector(
  selectSuggestedUserState,
  fromSuggestedUser.selectAllSuggestedUsers
);
